import { render, staticRenderFns } from "./PerformanceAssignmentEdit.vue?vue&type=template&id=5e4db0a3&scoped=true&"
import script from "./PerformanceAssignmentEdit.vue?vue&type=script&lang=js&"
export * from "./PerformanceAssignmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4db0a3",
  null
  
)

export default component.exports